// extracted by mini-css-extract-plugin
export var csatScore = "_nv-5";
export var header = "_nv-1";
export var panelWrapper = "_nv-2";
export var postPreview = "_nv-3";
export var rightContent = "_nv-0";
export var wrappingText = "_nv-4";